import { useEffect, useState } from 'react';
import axiosInstance from '../api/axiosInstance';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Title
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Title);

const PollViewer = ({ threadId }) => {
  const [data, setData] = useState(null);
  const [voting, setVoting] = useState(false);
  const [selected, setSelected] = useState(null);
  const [error, setError] = useState(null);

  const load = () => {
    axiosInstance
      .get(`/poll/results/${threadId}`)
      .then(res => {
        setData(res.data);
      })
      .catch(() => setError('Fehler beim Laden der Umfrage.'));
  };

  useEffect(() => {
    load();
  }, [threadId]);


  const handleVote = async () => {
    if (selected === null) return;
    setVoting(true);
    try {
      await axiosInstance.post('/poll/vote', {
        threadId,
        optionIndex: selected
      });
      load();
    } catch (err) {
      setError(err.response?.data?.error || 'Fehler beim Abstimmen.');
    } finally {
      setVoting(false);
    }
  };

  if (error) {
    return <div className="alert alert-error mt-4">{error}</div>;
  }

  if (!data) {
    return <div className="mt-4">Lade Umfrage…</div>;
  }

  if (data.alreadyVoted) {
    return (
      <div className="mt-6">
        <h3 className="font-bold text-lg mb-2">Ergebnisse</h3>
        <Bar
          data={{
            labels: data.options,
            datasets: [
              {
                label: 'Stimmen',
                data: data.votesPerOption,
                backgroundColor: '#448f65'
              }
            ]
          }}
          options={{
            responsive: true,
            indexAxis: 'y',
            plugins: {
              legend: { display: false },
              tooltip: {
                enabled: true,
                callbacks: {
                  label: context => `${context.label}: ${context.raw} Stimme(n)`
                }
              }
            },
            scales: {
              x: {
                beginAtZero: true,
                ticks: { precision: 0, stepSize: 1 }
              }
            },
            elements: {
              bar: {
                borderRadius: 6
              }
            }
          }}
        />
        <p className="mt-2 text-sm text-gray-500">{data.totalVotes} Stimme(n)</p>
      </div>
    );
  }

  return (
    <div className="mt-6">
      <h3 className="font-bold text-lg mb-2">Abstimmung</h3>
      <form
        onSubmit={e => {
          e.preventDefault();
          handleVote();
        }}
      >
        {data.options.map((opt, idx) => (
          <label key={idx} className="flex items-center gap-2 mb-2">
            <input
              type="radio"
              name="vote"
              value={idx}
              checked={selected === idx}
              onChange={() => setSelected(idx)}
              className="radio radio-success"
            />
            <span>{opt}</span>
          </label>
        ))}
        <button
          type="submit"
          className="btn btn-success mt-2"
          disabled={selected === null || voting}
        >
          {voting ? 'Stimme wird gespeichert…' : 'Abstimmen'}
        </button>
      </form>
    </div>
  );
};

export default PollViewer;
